
<template>
    <div>
        <transition name="component-fade" mode="out-in">
        <div class="shop_container" v-if="isLoad">
            <div class="shop-header">
                <a :href="url_prefix+'/specialofer'" class="button absolute-button" style="display:none">Prinde oferta de sezon!</a>
                <div class="tabs-selector">
                    <div class="tabs-selector-wrapper">
                        <div class="tab" v-for="category of categories" :class="{'active':active_tab==category.slug}" @click="active_tab=category.slug" v-html="category.label"></div>
                    </div>
                </div>
            </div>
            <div class="products-list" v-if="active_tab != 'camps'">
                <div v-for="product of products" class="white_container shop_wrap" :class="[product.ribbon.title !== null?'highlight':null]">
                    <div class="highlight_wrap" v-if="product.ribbon.title !== null">
                        <div class="icon-thumbs-up"></div>
                        <p>{{product.ribbon.title}}</p>
                    </div>
                    <div class="text_wrap">
                        <h2>{{product.qty}}</h2>
                        <h4>{{product.title}}</h4>
                        <p class="old_price" :style="{opacity: product.price.sale !== null?1:0}">{{formatPrice(round2(product.price.regular))}}</p>
                        <p class="price" v-if="product.price.sale !== null">{{formatPrice(round2(product.price.sale))}}</p>
                        <p class="price" v-if="product.price.sale === null">{{formatPrice(round2(product.price.regular))}}</p>
                        <p>{{formatPrice(round2(product.price.unit),product.currency)}}/{{$t("shop.LBL_LECTIE_PRICE")}}</p>
                        <p :style="{opacity: product.price.sale !== null?1:0}">{{$t("shop.LBL_DISCOUNT_VALUE")}} {{product.price.discount}}%</p>
                        <button v-on:click="startPaymentFlow(product)" class="button" v-html="$t('shop.BTN_MAKE_ORDER')"></button>
                    </div>
                </div>
            </div>
            <transition-group tag="div" class="products-list camps-list" v-if="active_tab == 'camps'" name="bounce">
                <div v-for="camp of products" class="white_container shop_wrap" :class="{'access':camp.access}" :key="camp.id">
                    <div class="camp-header">
                        <div class="camp-title">{{$t("shop.LBL_LEVEL_"+camp.level)}}</div>
                        <p v-html="$t('shop.LBL_LEVEL_'+camp.level+'_DESCRIPTION')"></p>
                    </div>
                    <table>
                        <tr>
                            <td>Perioada</td>
                            <td><span v-html="camp.date"></span></td>
                        </tr>
                        <tr>
                            <td>Localitatea</td>
                            <td><span v-html="camp.branch"></span></td>
                        </tr>
                        <tr>
                            <td>Locația</td>
                            <td><span v-html="camp.office"></span></td>
                        </tr>
                        <tr>
                            <td>Programul</td>
                            <td><span><a href="https://sah.md/docs/programul%20tabara.pdf" target="_blank" style="color:#05C46B;text-decoration:underline;">Program</a></span></td>
                        </tr>
                        <tr>
                            <td>Locuri</td>
                            <td><span v-html="camp.places_left"></span></td>
                        </tr>
                        <tr>
                            <td>Rezervează</td>
                            <td><span style=""><a :href="camp.join_link" target="_blank" style="color:#CF0920;text-decoration:none;">Rezervează</a></span></td>
                        </tr>
                    </table>
                    <div class="product-info" v-if="camp.product">
                        <template v-if="camp.product && camp.product.price.discount">
                            <div class="price-wrapper">
                                <span class="discount-price">{{formatPrice(round2(camp.product.price.regular),camp.product.currency)}}</span>
                                <span class="price">{{formatPrice(round2(camp.product.price.sale),camp.product.currency)}}</span>
                            </div>
                            <p v-if="camp.product.price.discount_till">Reducere {{camp.product.price.discount}}% până pe {{camp.product.price.discount_till_day}} {{$t("strings.MONTH_"+camp.product.price.discount_till_mon)}}</p>
                            <p v-else>Reducere {{camp.product.price.discount}}% până</p>
                            <button v-on:click="startPaymentFlow(camp.product)" class="button" v-html="$t('shop.BTN_MAKE_ORDER')"></button>
                        </template>
                        <template v-else>
                            <span class="price">{{formatPrice(round2(camp.product.price.regular),camp.product.currency)}}</span>
                            <button v-on:click="startPaymentFlow(camp.product)" class="button" v-html="$t('shop.BTN_MAKE_ORDER')"></button>
                        </template>
                    </div>
                </div>
            </transition-group>
        </div>
        </transition>
        <PayMethodPopup
            :show="showPayMethodPopup"
            :selectedProduct="selectedProduct"
            v-on:paymentEvent="paymentFlowRedirectRequest"
            v-on:closeEvent="showPayMethodPopup = !showPayMethodPopup">
        </PayMethodPopup>
        <PaySuccessPopup
            :show="showPaySuccessPopup"
            v-on:closeEvent="showPaySuccessPopup = !showPaySuccessPopup">
        </PaySuccessPopup>
        <PayErrorPopup
            :show="showPayErrorPopup"
            v-on:closeEvent="showPayErrorPopup = !showPayErrorPopup">
        </PayErrorPopup>
    </div>
</template>

<style lang="scss">
    @import "style.scss";
</style>

<script>
    import i18n from '@/i18n';
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import PayMethodPopup from './popups/PayMethodPopup';
    import PaySuccessPopup from './popups/PaySuccessPopup';
    import PayErrorPopup from './popups/PayErrorPopup';
    import {decodeHtml} from '@/utils/utils';
    import {formatPrice} from '@/utils/utils';
    import {rest} from '@/utils/utils';

    export default {
        name: 'Shop',
        components: {
            PayMethodPopup,
            PaySuccessPopup,
            PayErrorPopup
        },
        data: function () {
            return {
                isLoad: false,
                showPayMethodPopup: false,
                showPaySuccessPopup: false,
                showPayErrorPopup: false,
                selectedProduct: null,
                products: [],
                active_tab:'individual',
                categories:[
                    //{
                    //    slug:"maestro",
                    //    label:i18n.t('shop.LBL_TAB_MASTER_LESSONS')
                    //},
                    {
                        slug:"individual",
                        label:i18n.t('shop.LBL_TAB_INDIVIDUAL')
                    },
                    {
                        slug:"group",
                        label:i18n.t('shop.LBL_TAB_GROUP')
                    },
                ]
            }
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            }
        },
        created(){
            this.updateScheduleHours();
            let linkParams = this.$route.query;
            if (linkParams !== null) {
                if (linkParams.paymentStatus !== undefined) {
                    if (linkParams.paymentStatus === 'ok') {
                        //this.showPaySuccessPopup = true;
                      let query = new URLSearchParams(linkParams);
                      window.location.href = '/thank_you?' + query;
                    }
                    if (linkParams.paymentStatus === 'error') {
                        this.showPayErrorPopup = true;
                    }
                }
            }
        },
        mounted(){
            //Загрузим доступные категории 
            store.commit('loading/is', true);
            this.isLoad = false;
            //Получим товары из предложения
            rest.call("shop_categories",{},"GET").then((response)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
                if(response.status && response.status == "ok" && response.categories){
                    this.categories = response.categories;
                    console.log(this.categories);
                    const excludeSlugs = ['special', 'maestro', 'camps'];
                    this.categories = response.categories.filter(item => !excludeSlugs.includes(item.slug));
                    console.log(this.categories);

                }
                if(this.$route.query){
                    if(this.$route.query.category){
                        for(var x in this.categories){
                            if(this.categories[x].slug == this.$route.query.category){
                                this.active_tab = this.categories[x].slug;
                                break;
                            }
                        }
                    }
                }
            }).catch((error)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
            });
        },
        methods: {
            round2(num){
                return num;
            },
            startPaymentFlow(product) {
                this.selectedProduct = product;
                this.showPayMethodPopup = true;
            },
            updateScheduleHours() {
                store.commit('loading/is', true);
                this.isLoad = false;
                //Получим товары из предложения
                rest.call("shop_items",{
                    "category_slug":this.active_tab,
                    "currency":this.user.currency
                },"GET").then((response)=>{
                    this.isLoad = true;
                    store.commit('loading/is', false);
                    if(response.status && response.status == "ok" && response.products){
                        this.products = response.products;
                    }
                }).catch((error)=>{
                    this.isLoad = true;
                    store.commit('loading/is', false);
                });
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
            /**
             * Заказ товара
             */
            paymentFlowRedirectRequest(paymentInfo) {
                store.commit('loading/is', true);
                rest.call("proccess_offer",{
                    "product":paymentInfo.id,
                    "method":paymentInfo.payment_method,
                    "currency":this.user.currency,
                    "rate":paymentInfo.rateEURtoLEI,
                    "qty":paymentInfo.qty,
                    "offer":paymentInfo.offer,
                    "offer_product_id":paymentInfo.offer_product_id,
                    "promocode":paymentInfo.promocode
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.redirect){
                        window.location.href = decodeHtml(response.redirect);
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            }
        },
        watch:{
            active_tab(index){
                this.updateScheduleHours();
            }
        },
    }
</script>
